<div>
  <ngx-extended-pdf-viewer
    *ngIf="newsletterObject"
    [src]="'/rest/crm/newsletter/' + newsletterObject.uuid  + '/pdf'"
    [zoom]="zoom"
    [backgroundColor]="'#fafafa'"
    [showPresentationModeButton]="true"
    [showPrintButton]="false"
    [showTextEditor]="false"
    [showDownloadButton]="false"
    [showRotateButton]="false"
    [showSecondaryToolbarButton]="false"
    [showDrawEditor]="false"
    [showOpenFileButton]="false"
  ></ngx-extended-pdf-viewer>
</div>
